import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 1 · NIVEAU 2 — LE PINCEMENT.

     0:00  bloc B        16 s   pincement — la géographie se referme
     0:16  bloc B2       16 s   le Faucheur — première grande menace
     0:32  respiration    4 s   accalmie de fin

   Deuxième niveau du monde 1, sans boss. Il enchaîne directement sur le premier
   (pas d'intro : le monde est déjà installé) et se termine sur une respiration.

   ⚠️ Blocs 4 → 6 de l'ancien `monde-1`, re-basés (offset 36 s). L'espacement
   relatif est intact — b1 (16 s) finit exactement quand b2 démarre, b2 (16 s)
   finit quand la respiration commence.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-1-2',
  duration: 36,
  blocks: [
    { at: 0, wave: 'b1-pincement' },
    { at: 16, wave: 'b2-faucheur' },
    { at: 32, wave: 'respiration' },
  ],
});
